import * as React from "react";
import { Context } from "./_context";
export const PasscodeIcon = ({ size = 32, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[32] = /* @__PURE__ */ React.createElement("svg", { width: "2rem", height: "2rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m17.5 13.196 9.668-6.444 1.664 2.496L18.703 16l10.129 6.753-1.664 2.496-9.668-6.445V30h-3V18.802l-9.668 6.446-1.664-2.496 10.127-6.753L3.168 9.248l1.664-2.496 9.668 6.445L14.501 2h3L17.5 13.196Z", fill: "currentColor" }));
  return iconset[size];
};
PasscodeIcon.iconId = "s3IS8c";
